var _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcEth24(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24.002,
    viewBox: "0 0 24 24.002",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 .003h24v24h-24z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m23.64 14.905a12 12 0 1 1 -8.74-14.545 12 12 0 0 1 8.74 14.545z",
    fill: "#fff",
    transform: "translate(0 -.001)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.858 3.628)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m383.612 0-.112.382v11.075l.112.112 5.141-3.039z",
    fill: "#343434",
    transform: "translate(-378.471)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.141 0-5.141 8.53 5.141 3.039z",
    fill: "#8c8c8c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m387.3 727.927-.063.077v3.945l.063.185 5.144-7.245z",
    fill: "#3c3c3b",
    transform: "translate(-382.162 -715.385)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.141 732.135v-4.207l-5.141-3.038z",
    fill: "#8c8c8c",
    transform: "translate(0 -715.385)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m392.07 477.706 5.141-3.039-5.141-2.337z",
    fill: "#141414",
    transform: "translate(-386.929 -466.137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 474.667 5.141 3.039v-5.376z",
    fill: "#393939",
    transform: "translate(0 -466.137)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEth24);
export default __webpack_public_path__ + "static/media/ic_eth_24.6b1d8a1dc304aaaf675d69f3b1888cf0.svg";
export { ForwardRef as ReactComponent };